import axios from 'axios';
import { baseUrl } from '@/config';

export default {
  /**
   *  IP 접근 건수 및 정보를 조회한다.
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   * @author jda
   */
  getIpList(params) {
    return axios.post(`${baseUrl}/performance/analysis/apm/get-ip-list.do`, params);
  },
  /**
   * 에이전트 카운트를 조회한다.
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   * @author jda
   */
  getUserAgentList(params) {
    return axios.post(`${baseUrl}/performance/analysis/apm/get-user-agent-list.do`, params);
  },
  /**
   * EUM 네비게이션을 조회한다.
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   * @author jda
   */
  getEumNavList(params) {
    return axios.post(`${baseUrl}/performance/analysis/apm/get-eum-nav-list.do`, params);
  },
  /**
   * EUM AJAX를 조회한다.
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   * @author jda
   */
  getEumAjaxList(params) {
    return axios.post(`${baseUrl}/performance/analysis/apm/get-eum-ajax-list.do`, params);
  },
  /**
   * EUM 스크립트 에러 리스트를 조회한다.
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   * @author jda
   */
  getEumJsErrorList(params) {
    return axios.post(`${baseUrl}/performance/analysis/apm/get-eum-js-error-list.do`, params);
  },
  /**
   * Alert 상세 리스트를 조회한다.
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   * @author jda
   */
  getAlertRawList(params) {
    return axios.post(`${baseUrl}/performance/analysis/apm/get-alert-raw-list.do`, params);
  },
  /**
   * EUM 네비게이션 상세 리스트를 조회한다.
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   * @author jda
   */
  getEumNavRawList(params) {
    return axios.post(`${baseUrl}/performance/analysis/apm/get-eum-nav-raw-list.do`, params);
  },
  /**
   * EUM Ajax 상세 리스트를 조회한다.
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   * @author jda
   */
  getEumAjaxRawList(params) {
    return axios.post(`${baseUrl}/performance/analysis/apm/get-eum-ajax-raw-list.do`, params);
  },
  /**
   * EUM 스크립트 에러 상세 리스트를 조회한다.
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   * @author jda
   */
  getEumJsErrorRaw(params) {
    return axios.post(`${baseUrl}/performance/analysis/apm/get-eum-js-error-raw.do`, params);
  },
  updateAlertInfo(params) {
    return axios.post(`${baseUrl}/performance/analysis/apm/update-alert-info.do`, params);
  },
  /**
   * 네비게이션 목록의 차트 데이터를 조회한다.
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   * @author jda
   */
  getEumRawChartData(params) {
    return axios.post(`${baseUrl}/performance/analysis/apm/get-eum-${params.tabName.toLowerCase()}-raw-chart-data.do`, params);
  },
};



// WEBPACK FOOTER //
// ./src/api/performance/apm/count-info.js